<template>
  <div>
    <div class="ui form">
      <div class="required field">
        <label for="reservation_type">Choose Package</label>
        <select
          class="ui fluid search dropdown"
          id="doctor-search"
          v-model="package_id"
          name="doctor"
        >
          <option value="">Choose Package</option>
          <option :value="p.id" v-for="p in packages" :key="p.id">
            {{ p.name }}
          </option>
        </select>
      </div>
    </div>

    <table class="ui celled center aligned table">
      <thead>
        <tr>
          <th width="18%">Sevice</th>
          <th width="12%">Pulse</th>
          <th width="12%">Power 1</th>
          <th width="12%">Power 2</th>
          <th width="8%">Skin type</th>
          <th width="12%">Cooling</th>
          <th>Note</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(usage, index) in usages" :key="index">
          <td>
            <select
              class="ui fluid search dropdown package-search"
              name="doctor"
              v-model="usage.service_id"
            >
              <option value="">Choose Serivce</option>
              <option :value="p.id" v-for="p in VisitServices.DATA" :key="p.id">
                {{ p.name }}
              </option>
            </select>
          </td>
          <td> 
            <div class="ui fluid input">
              <input type="number" placeholder="Pulses" v-model="usage.quantity">
            </div>
          </td>
          <td> 
            <div class="ui fluid input">
              <input type="number" placeholder="Power 1"  v-model="usage.power1">
            </div>
          </td>
          <td> 
            <div class="ui fluid input">
              <input type="number" placeholder="Power 2" v-model="usage.power2">
            </div>
          </td>
          <td>
            <select
              class="ui fluid search dropdown package-search"
              v-model="usage.skinType"
            >
              <option value="">Choose Skin type</option>
              <option :value="1"> 1 </option>
              <option :value="2"> 2 </option>
              <option :value="3"> 3 </option>
              <option :value="4"> 4 </option>
              <option :value="5"> 5 </option>
              <option :value="6"> 6 </option>
            </select>
          </td>
          <td> 
            <div class="ui fluid input">
              <input type="number" placeholder="Cooling" v-model="usage.cooling">
            </div>
          </td>
          <td> 
            <div class="ui fluid input">
              <input type="text" placeholder="Note" v-model="usage.note">
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="ui blue right floated button"
          style="background-color: #092442"
          @click="save()">
      {{ $t('save') }}
    </div>
  </div>  
</template>

<script>
export default {
  props: {
    reservationVisitId: { type: Number, required: true },
    packages: { type: Array, required: true}
  },
  data() {
    return {
      usages: [{
        service_id: null,
        quantity: null,
        power1: null,
        power2: null,
        skinType: null,
        cooling: null,
        note: null
      }],
      package_id: null,
    }
  },
  watch: {
    usages: {
      handler: function () {
        const lastUsage = this.usages[this.usages.length - 1]
        
        if (this.validateUsage(lastUsage)) {
          this.usages.push({
            service_id: null,
            quantity: null,
            power1: null,
            power2: null,
            skinType: null,
            cooling: null,
            note: null
          })
        }

        this.$nextTick(() => {
          $('.dropdown').dropdown()
        })
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('.dropdown').dropdown()
    });
  },
  methods: {
    validateUsage (usage) {
      return usage.service_id && usage.quantity && usage.power1 && 
        usage.power2 && usage.cooling && usage.skinType 
    },
    save() {
      const filteredUsages = this.usages.filter(usage => this.validateUsage(usage))
      if (filteredUsages.length && this.package_id) {
        this.$http.post(`reservation_visits/${this.reservationVisitId}/add/medical-machine/usage`, { 
          package_id: this.package_id,
          usages: {
            details: filteredUsages 
          }
        }).then(response => {
          this.$emit('medical-machines-services-change', {
            data: {
              packageUsages: response.data
            }
          })
        })
      }
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/visits/visit_components/MedicalMachineUsageForm.vue